export const CLIENT_LANGUAGE_LOCALSTORAGE_KEY = 'client_language';
export const CLIENT_LANGUAGES_LOCALSTORAGE_KEY = 'client_languages';
